import { FormattedMessage, useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { Divider, Form, notification } from 'antd';

import TaskForm, {
  TaskFormData,
} from '@/components/Operational/Tasks/TaskForm';

import { PageProps } from '@/types/PageProps';

import TabContentWrapper from '@/components/_common/TabContentWrapper';
import { SaveButton } from '@/components/_common/Buttons';
import { useCreateTask } from '@/core/domain/operational/Tasks/Tasks.hooks';
import { CreateTaskRequest } from '@/core/domain/operational/Tasks/Tasks.types';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import ButtonBack from '@/components/_common/ButtonBack';

function CreateTaskPage({ route }: PageProps) {
  const intl = useIntl();
  const history = useHistory();
  const [form] = Form.useForm<TaskFormData>();

  const mutation = useCreateTask();

  const handleSaveClick = async () => {
    try {
      const values = await form.validateFields();

      const obj: CreateTaskRequest = {
        active: true,
        ...values,
        subArea: {
          id: +values.subAreaId,
        },
        taskPriceSet: values.taskPriceSet?.map((item) => ({
          companyId: item.companyId,
          price: item.price ?? 0,
          priceFixed: item.priceFixed ?? 0,
          commissionPercentage: item.commissionPercentage,
        })),
      };

      const response = await mutation.mutateAsync(obj);

      notification.success({
        message: intl.formatMessage({
          id: 'tasks.create.notification.success',
        }),
        description: intl.formatMessage({
          id: 'tasks.create.notification.successDescription',
        }),
      });

      history.push(`/app/operational/tasks/${response.id}`);
    } catch (err) {
      notification.error({
        message: intl.formatMessage({
          id: 'tasks.create.notification.error',
        }),
        description: intl.formatMessage({
          id: 'tasks.create.notification.errorDescription',
        }),
      });
    }
  };

  return (
    <TabContentWrapper
      title={route.name}
      extra={
        <SaveButton
          type="primary"
          onClick={handleSaveClick}
          loading={mutation.isLoading}
        >
          <FormattedMessage id="commons.form.button.save" />
        </SaveButton>
      }
    >
      <TaskForm form={form} />

      <Divider />

      <SpaceForButton>
        <ButtonBack path="/app/operational/tasks" />
      </SpaceForButton>
    </TabContentWrapper>
  );
}

export default CreateTaskPage;
